import { Localized, RichtextValue, UnfetchedFieldValue } from "@robe/core-types";

export const resolveLocalizedRichtextValueLinks = (localizedValue: Localized<RichtextValue | RichtextValue[]>, locales: string[]) =>
  Object.entries(localizedValue)
    .filter(([l]) => locales.includes(l))
    .map(([_, value]) =>
      Array.isArray(value)
        ? value.map((listValue) => listValue.links).flat() // Localized list value
        : value.links
    )
    .flat();

/**
 * Unfetched value can also be a relation and is considered file value only if it's found in image infos.
 */
export const isUnfetchedFieldValue = (v: any): v is UnfetchedFieldValue =>
  v && typeof v === "object" && "id" in v && typeof v.id === "number";

export const isRichtextValue = (v: any): v is RichtextValue =>
  v &&
  typeof v === "object" &&
  "links" in v &&
  "value" in v &&
  Array.isArray(v.links) &&
  Array.isArray(v.value) &&
  Object.keys(v).length === 2;

export const isLocalizedValue = (localizedValue: unknown, locales: string[]): localizedValue is Record<string, unknown> =>
  localizedValue !== null &&
  !Array.isArray(localizedValue) &&
  typeof localizedValue === "object" &&
  // All value keys are valid locales
  Object.keys(localizedValue).every((key) => locales.includes(key));

export const isLocalizedUnfetchedFieldValue = (
  localizedValue: unknown,
  locales: string[]
): localizedValue is Localized<UnfetchedFieldValue> =>
  isLocalizedValue(localizedValue, locales) &&
  Object.values(localizedValue).every((value) =>
    Array.isArray(value)
      ? value.every((listValue) => isUnfetchedFieldValue(listValue)) // Localized list value
      : isUnfetchedFieldValue(value)
  );

export const isLocalizedRichtextValue = (localizedValue: unknown, locales: string[]): localizedValue is Localized<RichtextValue> =>
  isLocalizedValue(localizedValue, locales) &&
  Object.values(localizedValue).every((value) =>
    Array.isArray(value)
      ? value.every((listValue) => isRichtextValue(listValue)) // Localized list value
      : isRichtextValue(value)
  );
